export const securityObjectiveKeys = {
  all: ["securityObjective"] as const,
  project: (projectId: string | null) => [...securityObjectiveKeys.all, projectId] as const,
};
